<i18n>
{
"en": {
  "SUCCESS": "{component} is successfully saved!",
  "CANCEL": "Cancel",
  "SAVE": "Save",
  "SAVING": "Saving..",
  "ERROR": "Error",
  "CLOSE": "Close"  
},
"ar": {
  "SUCCESS": "تم حفظ  {component}!",
  "CANCEL": "الغاء",
  "SAVE": " حفظ",
  "SAVING": "..احتفاظ",
  "ERROR": "خطأ",
  "CLOSE": "أغلق"
}
}
</i18n>
<template>
<div class="wisave">
  <div class="clearfix">
    <el-row>
      <span style="line-height: 36px;">{{ title }}</span>
      <el-button v-if="isAllowed('save')" :loading="saving" type="primary" @click="save()">{{saving ? $t('SAVING') : $t('SAVE')}}</el-button>
      <el-button @click="$router.go(-1)">{{$t('CANCEL')}}</el-button>
    </el-row>

  </div>
   <el-dialog
  :title="$t('ERROR')"
  v-model="error"
  size="tiny">

  <div class="el-alert el-alert--error">
    <i class="el-alert__icon el-icon-circle-cross is-big"></i>
    <div class="el-alert__content">
      <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message" v-html="printError(messageError)"></span>
      </div>
   </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
  </span>
</el-dialog>
  <el-auth-dialog @authBack="success" :visible.sync="sessionDialog" :configuration="data" message="REQUIREDAUTHENTICATION"></el-auth-dialog>
 </div>  
</template>

<script>
  import AuthDialog from '@/components/dialogs/Auth'
  export default {
    components: {'el-auth-dialog': AuthDialog},
    name: 'WiSave',
    componentName: 'WiSave',
    props: {
      data: {
        required: true,
        type: Object,
        default: function () {
          return {}
        }
      },
      form: {
        type: Array,
        default: function () {
          return []
        }
      },
      title: {
        type: String,
        default: ''
      },
      redirect: {
        type: Boolean,
        default: true
      },
      auth: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        saving: false,
        messageBox: false,
        sessionDialog: false,
        message: [],
        error: false,
        fields: {}
      }
    },
    computed: {
    },
    mounted () {
      this.switchLanguage()
    },
    methods: {
      printError (message) {
        if (this.saving === null) return message + '</br>'
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      formValidated () {
        let errors = []
        let forms = {}
        let data = {}
        let ref = this.$parent.$parent.$refs
        this.form.forEach(function (form) {
          forms[form] = ref[form]
        })
        this.saving = null
        for (let form in forms) {
          for (let field in forms[form].fields) {
            let fields = forms[form].fields
            let formField = fields[field].prop
            let label = fields[field].label === undefined ? fields[field].$parent.labelSuffix : fields[field].label
            this.fields[formField] = {rules: fields[field].rules, name: form}
            forms[form].validateField(formField, function (errorMessage) {
              if (errorMessage === '') return
              if (errorMessage.indexOf(label) >= 0) errors.push(errorMessage)
              else errors.push(label + ' ' + errorMessage)
            })
            if (typeof fields[field].rules === 'object' && fields[field].rules.type === 'date') {
              for (let key in this.data) {
                if (data[key] === undefined) data[key] = Object.assign({}, this.data[key])
                if (data[key][formField] !== undefined) data[key][formField] = this.$moment(fields[field].fieldValue).format('YYYY-MM-DD')
              }
            }
          }
        }
        if (errors.length === 0) return data
        this.message = errors
        this.error = true
        return false
      },
      save () {
        let data = this.formValidated()
        if (!data) return
        if (this.auth) return (this.sessionDialog = true)
        let self = this
        self.saving = true
        let path = self.$route.path.split('/')
        this.$http.post('/' + path[2] + '/save', data).then(function (response) {
          let data = response.data
          self.saving = false
          self.error = data.error
          if (!self.error) return self.success(data)
          let ref = self.$parent.$parent.$refs
          self.message = []
          self.saving = null
          for (let _message in data.message) {
            let form = self.fields[_message]
            let field = ref[form.name].fields.filter(field => field.prop === _message)[0]
            let rule = field.rules.filter(rule => rule.validate === true)[0]
            if (rule) {
              rule.validator = function (rule, value, callback) {
                callback('')
              }
            }
            ref[form.name].validateField(_message, function (error) {
              self.message.push(error)
            })
          }
        }).catch(function () {
        })
      },
      success (data) {
        let path = this.$route.path.split('/')
        delete path.splice(-1, 1)
        if (this.redirect) this.$router.push({path: path.join('/')})
        this.$message({message: this.$t(data.message, {component: this.title.split(' ')[1]}), type: 'success', showClose: true})
        return
      }
    }
  }
</script>

<style>
 .wisave .el-card__header .el-dropdown, .el-card__header  .el-dialog__footer .el-button {float: none !important}
</style>



// WEBPACK FOOTER //
// Save.vue?0b52ef26